module.exports = "/images/vendor/flag-icon-css/flags/1x1/vn.svg?a0081482192375c70656860e843b3c8d";